import { CaseTag } from '@debbie/common/dist/cases/index.js';
import { COMMON_DATE_FORMAT } from '@debbie/common/dist/constants.js';
import { h } from '@debbie/cortex/dist/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { useUpdateTypes } from '@debbie/cortex/dist/update-types/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import { X } from '../../Icons/index.js';
import Loading from '../../Loading.js';
import { findUpdateTypeFilter } from '../util.js';
// Standard
export const FilterDisplay = (props) => {
    return (React.createElement(Wrapper, null,
        React.createElement(Section, null, props.label),
        props.children,
        React.createElement(Section, { interactive: true, onClick: () => props.onRemove() },
            React.createElement(Cross, null))));
};
export const EnumDisplay = (property, options) => (props) => {
    const lang = useSelector((s) => s.lang);
    const filter = props.filter;
    // Handle not filter that wraps an in filter
    const isNotFilter = filter.type === 'not' && filter.filter?.type === 'in';
    const inFilter = isNotFilter
        ? filter.filter
        : filter.type === 'in'
            ? filter
            : null;
    if (!inFilter) {
        throw new Error('Unsupported filter type');
    }
    const match = 
    // @ts-expect-error
    inFilter.values.length == 1
        ? // @ts-expect-error
            options.find((option) => option.value === inFilter.values[0])
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterTypeConfig() }, isNotFilter
            ? // @ts-expect-error
                inFilter.values.length > 1
                    ? lang.views.noneOf
                    : lang.views.isNot
            : // @ts-expect-error
                inFilter.values.length > 1
                    ? lang.views.oneOf
                    : lang.views.is),
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterConfig() }, match != null
            ? match.label(lang)
            : // @ts-expect-error
                `${inFilter.values.length} ${lang.views.values}`)));
};
export const DateDisplay = (property) => (props) => {
    const lang = useSelector((s) => s.lang);
    const filter = props.filter;
    if (filter != null && filter.type !== 'gt' && filter.type !== 'lt') {
        throw new Error('Invalid filter');
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterTypeConfig() }, filter.type === 'gt' ? lang.views.after : lang.views.before),
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterConfig() }, moment(filter.value).format(COMMON_DATE_FORMAT))));
};
export const ListDisplay = (dataLoader, getKey, getLabel) => (props) => {
    const filter = props.filter;
    const lang = useSelector((s) => s.lang);
    // Handle not filter that wraps an in filter
    const isNotFilter = filter.type === 'not' && filter.filter?.type === 'in';
    const inFilter = isNotFilter
        ? filter.filter
        : filter.type === 'in'
            ? filter
            : null;
    if (!inFilter) {
        throw new Error('Unsupported filter type');
    }
    const loader = dataLoader();
    if (h.hasData(loader)) {
        const items = loader.data;
        const match = 
        // @ts-expect-error
        inFilter.values.length == 1
            ? // @ts-expect-error
                items.find((item) => getKey(item) === inFilter.values[0])
            : null;
        return (React.createElement(React.Fragment, null,
            React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterTypeConfig() }, isNotFilter
                ? // @ts-expect-error
                    inFilter.values.length > 1
                        ? lang.views.noneOf
                        : lang.views.isNot
                : // @ts-expect-error
                    inFilter.values.length > 1
                        ? lang.views.oneOf
                        : lang.views.is),
            React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterConfig() }, match != null
                ? getLabel(match, lang)
                : // @ts-expect-error
                    `${inFilter.values.length} ${lang.views.values}`)));
    }
    if (h.isLoading(loader)) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterConfig() },
                React.createElement(Loading, { width: "20px" }))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterConfig() })));
};
export const InputListDisplay = (props) => {
    const filter = props.filter;
    const lang = useSelector((s) => s.lang);
    // Handle not filter that wraps an in filter
    const isNotFilter = filter.type === 'not' && filter.filter?.type === 'in';
    const inFilter = isNotFilter
        ? filter.filter
        : filter.type === 'in'
            ? filter
            : null;
    if (!inFilter) {
        throw new Error('Unsupported filter type');
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterTypeConfig() }, isNotFilter
            ? // @ts-expect-error
                inFilter.values.length > 1
                    ? lang.views.noneOf
                    : lang.views.isNot
            : // @ts-expect-error
                inFilter.values.length > 1
                    ? lang.views.oneOf
                    : lang.views.is),
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterConfig() }, 
        // @ts-expect-error
        inFilter.values.length === 1
            ? // @ts-expect-error
                inFilter.values[0]
            : // @ts-expect-error
                `${inFilter.values.length} ${lang.views.values}`)));
};
export const BooleanDisplay = (options) => (props) => {
    const lang = useSelector((s) => s.lang);
    if (props.filter.type !== 'eq') {
        throw new Error('BooleanDisplay requires an eq filter');
    }
    const filter = props.filter;
    const value = filter.value;
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, null, lang.views.is),
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterConfig() }, value
            ? options?.yesName
                ? options?.yesName(lang)
                : lang.misc.yes
            : options?.noName
                ? options?.noName(lang)
                : lang.misc.no)));
};
// Custom
export const AssociatedCaseDisplay = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, null, lang.views.is),
        React.createElement(Section, { interactive: true, role: "button", tabIndex: 0, onClick: props.toggleFilterConfig, onKeyDown: (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    props.toggleFilterConfig();
                }
            } }, props.filter.type === 'not'
            ? lang.views.associated
            : lang.views.notAssociated)));
};
export const PausedUpdatesDisplay = (props) => {
    const lang = useSelector((s) => s.lang);
    const originalFilter = props.filter;
    const isNotFilter = originalFilter.type === 'not' && originalFilter.filter?.type === 'and';
    const andFilter = isNotFilter
        ? originalFilter.filter
        : originalFilter.type === 'and'
            ? originalFilter
            : null;
    if (!andFilter) {
        throw new Error('PausedUpdatesDisplay requires an and filter or a not filter wrapping an and filter');
    }
    const updateTypesLoader = useUpdateTypes();
    const selectedFilter = findUpdateTypeFilter(andFilter.filters);
    const selected = selectedFilter && selectedFilter.type === 'in' ? selectedFilter.values : [];
    if (h.hasData(updateTypesLoader)) {
        const updateTypes = updateTypesLoader.data;
        const match = selected.length == 1
            ? updateTypes.find((ut) => ut.updateTypeId === selected[0])
            : null;
        return (React.createElement(React.Fragment, null,
            React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterTypeConfig() }, isNotFilter
                ? selected.length > 1
                    ? lang.views.noneOf
                    : lang.views.isNot
                : selected.length > 1
                    ? lang.views.oneOf
                    : lang.views.is),
            React.createElement(Section, { interactive: true, onClick: () => {
                    props.toggleFilterConfig();
                } }, match != null
                ? (lang.updateTypes[match.updateTypeId] ?? match.label)
                : `${selected.length} ${lang.views.values}`)));
    }
    if (h.isLoading(updateTypesLoader)) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterConfig() },
                React.createElement(Loading, { width: "20px" }))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterConfig() })));
};
export const PropertyDisplay = (props) => {
    const lang = useSelector((s) => s.lang);
    const typesLoader = usePropertyTypes();
    const filter = props.filter;
    if (filter.type != 'and') {
        throw new Error('Invalid filter');
    }
    const handleFilter = filter.filters.find((f) => f.type === 'eq' &&
        f.property[0] === 'properties' &&
        f.property[1] === 'handle');
    const dataFilter = filter.filters.find((f) => (f.type === 'eq' || f.type === 'in') &&
        f.property[0] === 'properties' &&
        f.property[1] === 'data');
    if (handleFilter == null ||
        handleFilter.type != 'eq' ||
        dataFilter == null ||
        (dataFilter.type != 'eq' && dataFilter.type != 'in') ||
        h.isError(typesLoader)) {
        return (React.createElement(Section, { interactive: true, onClick: () => {
                props.toggleFilterConfig();
            } }));
    }
    if (h.hasData(typesLoader)) {
        const handleType = typesLoader.data.find((t) => t.handle === handleFilter.value);
        return (React.createElement(React.Fragment, null,
            React.createElement(Section, { interactive: true, onClick: () => {
                    props.toggleFilterConfig();
                } },
                handleType?.label,
                ' ',
                dataFilter.type === 'in' && dataFilter.values.length > 1
                    ? lang.views.oneOf
                    : lang.views.is,
                ' ',
                dataFilter.type === 'in'
                    ? // @ts-expect-error
                        dataFilter.values.map((v) => JSON.parse(v)).join(', ')
                    : // @ts-expect-error
                        JSON.parse(dataFilter.value))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterConfig() })));
};
export const CaseTagDisplay = (props) => {
    const lang = useSelector((s) => s.lang);
    const filter = props.filter;
    // Handle not filter that wraps an in filter
    const isNotFilter = filter.type === 'not' && filter.filter?.type === 'in';
    const inFilter = isNotFilter
        ? filter.filter
        : filter.type === 'in'
            ? filter
            : null;
    if (!inFilter) {
        throw new Error('Unsupported filter type');
    }
    const options = Object.values(CaseTag).map((ct) => ({
        value: ct,
        label: (lang) => lang.caseTags[ct],
    }));
    const match = 
    // @ts-expect-error
    inFilter.values.length == 1
        ? // @ts-expect-error
            options.find((option) => option.value === inFilter.values[0])
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterTypeConfig() }, isNotFilter
            ? // @ts-expect-error
                inFilter.values.length > 1
                    ? lang.views.noneOf
                    : lang.views.isNot
            : // @ts-expect-error
                inFilter.values.length > 1
                    ? lang.views.oneOf
                    : lang.views.is),
        React.createElement(Section, { interactive: true, onClick: () => props.toggleFilterConfig() }, match != null
            ? match.label(lang)
            : // @ts-expect-error
                `${inFilter.values.length} ${lang.views.values}`)));
};
const Wrapper = styled.div `
  display: flex;
  border-radius: 4px;
  border: 1px solid lightgray;
  user-select: none;
`;
const Section = styled.div `
  padding: 4px;
  pointer: none;
  cursor: ${(p) => (p.interactive ? 'pointer' : 'default')};

  &:hover {
    background-color: ${(p) => p.interactive
    ? `color-mix(in hsl, ${THEME.COLOR_GREY}, transparent 80%)`
    : 'none'};
  }
`;
const Cross = styled(X) `
  cursor: pointer;
`;
//# sourceMappingURL=FilterDisplay.js.map